module.exports = __webpack_public_path__ + "static/media/gt.e2a8f7ec.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gt.svg
// module id = 1247
// module chunks = 0